import * as types from '../actions/actionType';

const recommendationReducer = (state = {}, action) => {
    switch (action.type) {
        case types.GET_ALL_RECOMMENDATION:
            return {
                ...state,
                recommendations: { isLoading: action.isLoading },
            };
        case types.GET_ALL_RECOMMENDATION_SUCCESS:
            return {
                ...state,
                recommendations: {
                    payload: action.payload,
                    isLoading: false,
                },
            };
        case types.UPDATE_ALL_RECOMMENDATION_SUCCESS: {
            const index = state.recommendations.payload.findIndex(row => row.id === action.payload.id);
            const updatedPayload = [
                ...state.recommendations.payload.slice(0, index),
                action.payload,
                ...state.recommendations.payload.slice(index + 1),
            ];
            return {
                ...state,
                recommendations: {
                    payload: updatedPayload,
                    isLoading: false,
                },
            };
        }
        case types.GET_RECOMMENDATIONS_FOR_RANGE:
            return {
                ...state,
                recommendations: { isLoading: action.isLoading },
            };
        default:
            return state;
    }
};
export default recommendationReducer;
